import { createSelector } from 'reselect'

export const getElementName = (state, props) => {
  return state['view-card'].elements.elementsById[props.id].elementName
}

export default () => createSelector(
  [getElementName],
  (elementName) => ({
    elementName
  })
)
